import React from 'react'

const Fitness = () => {
  return (
    <div>Fitness</div>
  )
}

export default Fitness